import React, { useState } from 'react';
import {
    Box,
    Typography,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import QuizIcon from '@mui/icons-material/Quiz';

/**
 * Course Content Component
 * Populates the Accordion using the outline prop.
 */
function Content({ outline }) {
    // State to control which accordion is expanded
    const [expanded, setExpanded] = useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    return (
        <Box sx={{ mb: 4 }}>
            {/* Title */}
            <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2, color: '#333' }}>
                Course Content
            </Typography>

            {/* Accordion for Modules */}
            {outline.map((module, index) => (
                <Accordion
                    key={index}
                    expanded={expanded === `panel${index}`}
                    onChange={handleChange(`panel${index}`)}
                    disableGutters
                    square
                    sx={{
                        borderTop: index === 0 ? '1px solid #ddd' : 'none',
                        borderBottom: '1px solid #ddd',
                        '&:last-of-type': { borderBottom: '1px solid #ddd' },
                        '&:before': { display: 'none' }, // Removes the default accordion divider
                    }}
                >
                    {/* Accordion Summary */}
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        sx={{
                            backgroundColor: '#f8fafc',
                            '&:hover': { backgroundColor: '#f0f4f8' },
                        }}
                    >
                        <Typography sx={{ fontWeight: 'bold', color: '#333' }}>
                            {module.title}
                        </Typography>
                    </AccordionSummary>

                    {/* Accordion Details */}
                    <AccordionDetails>
                        <List>
                            {module.lessons.map((lesson, lessonIndex) => (
                                <ListItem key={lessonIndex} sx={{ pl: 0 }}>
                                    <ListItemIcon>
                                        {lesson.type === 'video' ? (
                                            <PlayCircleOutlineIcon sx={{ color: 'primary.main' }} />
                                        ) : (
                                            <QuizIcon sx={{ color: 'secondary.main' }} />
                                        )}
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={lesson.title}
                                        sx={{ color: '#555' }}
                                    />
                                </ListItem>
                            ))}
                        </List>
                    </AccordionDetails>
                </Accordion>
            ))}
        </Box>
    );
}

export default Content;
